import type { PropsWithChildren } from "react";
import { css, styled } from "styled-components";

import { useSelector } from "common/utilities/react-redux";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { useWeforumUrl } from "common/utilities/useWeforumUrl";
import type { TrackPage } from "domains/analytics/types";
import { getIsAuthenticated } from "domains/authentication/selectors";
import { useGoToMembership } from "entities/user/utils";

const StyledLandingTag = css`
  display: flex;
  padding: 3px 10px;
  background-color: ${({ theme }) => theme.colors.yellow};
  color: ${({ theme }) => theme.colors.black};
  border-radius: 4px;
  text-transform: uppercase;
  width: fit-content;
  text-decoration: none;
  font-weight: bold;
  margin-bottom: 12px;
`;

const StyledLink = styled.a`
  ${StyledLandingTag}
`;

const StyledDiv = styled.div`
  cursor: pointer;
  ${StyledLandingTag}
`;

type DigitalMemberTagProps = PropsWithChildren & { className?: string; text?: string; trackPage: TrackPage };

export const DigitalMemberTag = ({ className, text, trackPage }: DigitalMemberTagProps) => {
  const goToMembership = useGoToMembership();
  const isAuthenticated = useSelector(getIsAuthenticated);
  const track = useTrack();
  const translate = useTranslate();
  const weforumUrl = useWeforumUrl();

  const onClick = () => {
    track({ name: "Upgrade", page: trackPage });
    goToMembership();
  };

  return isAuthenticated ? (
    <StyledDiv onClick={onClick} className={className}>
      {text ?? translate("app.about.key_points.membership_feature")}
    </StyledDiv>
  ) : (
    <StyledLink className={className} href={`${weforumUrl}/join-us/pricing`} rel="noopener noreferrer" target="_blank">
      {text ?? translate("app.about.key_points.membership_feature")}
    </StyledLink>
  );
};
